<template>
  <div class="footer">
    <div class="container">
      <a
        class="logomercedes"
        href="#"
      >
        <img
          src="../assets/img/mercedes-footer.svg"
          alt="Mercedes Benz"
        >
      </a>
      <a
        class="tovabbforbes"
        href="https://forbes.hu"
      >Tovább a <img
          src="../assets/img/forbes-logo.svg"
          alt="Forbes"
        >.hu-ra</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {

  },
  methods: {

  },
};
</script>

<style scoped lang="css">
.footer {
  background-color: #0f111b;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 60px;
  width: calc(100% - 120px);
}
.footer a {
  text-decoration: none;
  color: #fff;
}
.logomercedes {
  display: block;
}
.logomercedes img {
  height: 65px;
}
.tovabbforbes {
  display: flex;
  white-space: nowrap;
  align-items: baseline;
  font-size: 17px;
  text-transform: uppercase;
}
.tovabbforbes img {
  width: 78px;
  margin-left: 3px;
}
@media screen and (max-width: 767px) {
  .container {
    flex-direction: column;
    justify-content: center;
    padding: 40px 30px;
    width: calc(100% - 60px);
  }
  .logomercedes {
    margin-bottom: 30px;
  }
}
</style>
